import { render } from "./BasicUsage.vue?vue&type=template&id=e5f63c2a"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script